import { useContext } from 'react';
import { HappeningsContext } from '../contexts/happeningsContext';

const useHappeningsContext = () => {
  const context = useContext(HappeningsContext);
  if (!context) throw new Error('useHappeningsContext must be used within a HappeningsContext provider');
  return context;
};

export default useHappeningsContext;
